// PreguntasFrecuentes.js
import React, { useState } from 'react'; // Importar useState
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ModalReserva from '../componentes/ModalReserva';
import './PreguntasFrecuentes.css';

const PreguntasFrecuentes = () => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
  
    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

  return (
    <div className="preguntas-container">
      <Container>
         {/* Modal de Reserva */}
         <ModalReserva 
          show={showModal}
          onHide={handleCloseModal}
        />
        <div className="preguntas-header">
          <h1>Preguntas Frecuentes</h1>
          <Button 
            variant="primary" 
            className="volver-btn"
            onClick={() => navigate('/')}
          >
            ← Volver al Inicio
          </Button>
        </div>
        
        <div className="preguntas-content">
          <div className="preguntas-text">
            
            {/* Pregunta 1 */}
            <div className="faq-section">
              <h4>1. ¿Qué cubre la reserva de $2 USD y por qué no es reembolsable?</h4>
              <p>La reserva de <strong>$2 USD</strong> garantiza tu cupo en el curso y cubre gastos administrativos (gestión de expediente, acceso a la plataforma y recursos iniciales). <span className="highlight">Este monto no es reembolsable</span>, ya que implica costos operativos que el Proveedor asume desde el momento de tu inscripción. Si decides no continuar con el curso, podrás aplicar esta reserva a una futura convocatoria <strong>solo si nos notificas por escrito dentro de los primeros 5 días hábiles después de iniciado el curso</strong>. Pasado este plazo, perderás el derecho a la reserva.</p>
            </div>

            {/* Pregunta 2 */}
            <div className="faq-section">
              <h4>2. ¿Cómo funcionan los pagos del curso?</h4>
              <ul>
                <li><strong>Opción 1: Pago completo ($20 USD):</strong> Acceso inmediato a todos los módulos del curso, incluidas las 4 clases presenciales grupales.</li>
                <li><strong>Opción 2: Pagos semanales ($5 USD por semana):</strong> Dosificación del contenido según los pagos realizados. Por ejemplo, si pagas la primera semana, solo tendrás acceso al primer módulo y su clase presencial correspondiente. <span className="highlight">No es posible acceder a todo el material digital con un solo pago parcial</span>.</li>
              </ul>
            </div>

            {/* Pregunta 3 */}
            <div className="faq-section">
              <h4>3. ¿Puedo pausar el curso si elijo pagos semanales?</h4>
              <p>Sí. Si decides pausar, tu avance se guardará en la plataforma y podrás retomar donde lo dejaste al realizar el siguiente pago. Sin embargo, <span className="highlight">las clases presenciales grupales no se reprograman</span>: si no asistes, perderás la sesión correspondiente a esa semana.</p>
            </div>

            {/* Pregunta 4 */}
            <div className="faq-section">
              <h4>4. ¿Qué pasa si no completo los pagos semanales?</h4>
              <p>Perderás acceso a los módulos no pagados y a las clases presenciales futuras. Para reactivar tu participación, deberás <span className="highlight">ponerte al día con los pagos pendientes</span>.</p>
            </div>

            {/* Pregunta 5 */}
            <div className="faq-section">
              <h4>5. ¿Hay clases personalizadas fuera del horario grupal?</h4>
              <p>Sí. Ofrecemos <strong>clases personalizadas adicionales</strong> (1 a 1 o grupos reducidos) con un costo extra. Estas no están incluidas en el precio del curso ($20 USD) y requieren <span className="highlight">acuerdo previo con el facilitador</span>.</p>
            </div>

            {/* Pregunta 6 */}
            <div className="faq-section">
              <h4>6. ¿El soporte 24/7 incluye videollamadas?</h4>
              <p>El soporte vía WhatsApp es para resolver dudas puntuales (ej: acceso a la plataforma, envío de actividades). Las <strong>videollamadas</strong> están disponibles en <span className="highlight">horarios específicos publicados en la plataforma</span> y sujetas a la disponibilidad del facilitador.</p>
            </div>

            {/* Pregunta 7 */}
            <div className="faq-section">
              <h4>7. ¿Puedo acceder a todo el material digital si solo pago una parte?</h4>
              <p>No. El contenido se libera progresivamente según los pagos realizados. Por ejemplo, si pagas $5 USD, solo tendrás acceso al módulo correspondiente a esa semana. Esto garantiza un <span className="highlight">aprendizaje estructurado</span> y evita el uso indebido del material.</p>
            </div>

            {/* Pregunta 8 */}
            <div className="faq-section">
              <h4>8. ¿Qué requisitos técnicos debo cumplir?</h4>
              <ul>
                <li><strong>Edad mínima:</strong> 14 años o cursantes de 9° grado</li>
                <li><strong>Dispositivos:</strong> Celular con Android 13 o superior + computadora para programas especializados</li>
                <li><strong>Internet estable:</strong> Para acceder a sesiones en línea y materiales</li>
                <li><strong>Memoria USB de 32 GB:</strong> Para almacenar recursos descargables</li>
              </ul>
            </div>

            {/* Pregunta 9 */}
            <div className="faq-section">
              <h4>9. ¿El certificado tiene validez académica?</h4>
              <p>No. El <strong>certificado de participación</strong> acredita que completaste el curso, pero no es un título oficial. Es útil para enriquecer tu currículum o demostrar habilidades ante empleadores.</p>
            </div>

            {/* Pregunta 10 */}
            <div className="faq-section">
              <h4>10. ¿Qué ocurre si no asisto a las clases presenciales?</h4>
              <p>Las clases presenciales grupales no se repiten. Si faltas, perderás la sesión, pero podrás acceder a un <span className="highlight">resumen grabado en la plataforma</span> (sujeto a disponibilidad).</p>
            </div>

            {/* Pregunta 11 */}
            <div className="faq-section">
              <h4>11. ¿Cómo garantizan la seguridad de mis datos?</h4>
              <p>Los datos proporcionados (nombre, teléfono, email, etc.) se usan únicamente para gestionar tu participación en el curso. <span className="highlight">No compartimos información con terceros</span> sin tu consentimiento.</p>
            </div>

            {/* Pregunta 12 */}
            <div className="faq-section">
              <h4>12. ¿Qué pasa si el curso no se realiza por falta de inscritos?</h4>
              <p>En caso de cancelación del curso por parte del Proveedor, se <strong>devolverá el 100% de la reserva ($2 USD)</strong> o se ofrecerá cupo en la siguiente convocatoria.</p>
            </div>

            {/* CTA Final */}
            <div className="cta-section">
              <h3>¡INSCRÍBETE HOY!</h3>
              <p>La reserva de <strong>$2 USD</strong> es tu primer paso para asegurar un cupo y acceder a habilidades que impulsarán tu futuro digital. <span className="highlight">Recuerda:</span> Este monto no se reintegra, pero sí te da flexibilidad para unirte a futuras ediciones si comunicas tu decisión a tiempo.</p>
              <Button 
            variant="success" 
            className="reserva-btn"
            onClick={handleShowModal}
          >
            👉 Reservar Cupo Ahora
          </Button>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default PreguntasFrecuentes;